// extracted by mini-css-extract-plugin
module.exports = {"root":"footer_root__29srB","icons":"footer_icons__n003J","credits":"footer_credits__206z0","copyright":"footer_copyright__euESp"};